module.exports = __webpack_public_path__ + "static/media/johngilbert_resume_chs.3d6ed19a.jpg";